<template>
 <div>
   <div class="d-flex dkl-title-h4" style="background-color: #f3f1f1;">
     <h4>Schritte</h4>
     <a class="dkl-btn btn-md rounded-circle pull-right" @click.prevent="openStepModal" v-show="edit" href="#"><i class="fa fa-plus" aria-hidden="true"></i></a>
     <a class="dkl-btn btn-md pull-right" @click.prevent="openFullList" href="#" v-if="moreSteps"><i class="fa fa-angle-double-right fa-lg" aria-hidden="true"></i></a>
   </div>
   <div class="form-group row" v-show="!showList">
     <div class="table-responsive col-md-12">
       <table class="table table-striped mb-0">
         <tbody>
         <tr v-for="(step, index) in first5Steps" :key="index" :class="step.status === 'Offen' ? '' : 'strikethrough'">
           <td><input v-show="edit" type="checkbox" :id="'step' + index"  @click="stepCheckBox($event, step.id)" v-model="step.status !== 'Offen'" autocomplete="off"></td>
           <td class="keep-new-line">{{step.name }}</td>
           <td>{{step.status}}</td>
           <td>{{step.assigned_to}}</td>
           <td><div v-show="edit">
             <a class="dkl-btn rounded-circle pull-right" @click="editStep($event, index)" href="#"><i class="fa fa-info" aria-hidden="true"></i></a>
             <a class="dkl-btn rounded-circle pull-right" @click="confirmDeleteStep($event, index)" href="#"><i class="fa fa-trash" aria-hidden="true"></i></a>
           </div></td>
         </tr>
         </tbody>
       </table>
     </div>
     <div class="col-md-12" v-if="moreSteps"><a href="#" class="dkl-ml-075" @click.prevent="showList=true">{{
         $t('show_more')
       }}</a></div>
   </div>
   <step-modal
     title="StepModal"
     v-show="showStep"
     width="80%"
     ref="editStep"
     @close ="showStep = false">
     <h4 slot="header">{{ stepTitle }}</h4>
     <div slot="body">
         <div class="form-group row">
           <div class="col-md-12">
             <label class="col-form-label">{{ $t('description') }} <span class="text-danger">*</span></label>
             <textarea class="form-control" name="description" v-model="currentStep.name"></textarea>
             <span class="error-message text-danger" v-show="v$.currentStep.name.$errors.length>0">{{ $t('required_field') }}</span>
           </div>
         </div>
         <div class="form-group row">
           <div class="col-md-6">
             <label class="col-form-label">{{ $t('status') }}</label>
             <select class="form-control" name="status" v-model="currentStep.status">
               <option value="Offen">{{ $t('task_status.open') }}</option>
               <option value="In Bearbeitung">{{ $t('task_status.in_progress') }}</option>
               <option value="Annulliert">{{ $t('task_status.canceled') }}</option>
               <option value="Abgeschlossen">{{ $t('task_status.completed') }}</option>
               <option value="Duplikat">{{ $t('duplicate') }}</option>
             </select>
           </div>
           <div class="col-md-6">
             <label class="col-form-label">{{ $t('responsible_person') }}</label>
             <input type="text" class="form-control" name="responsible" v-model="currentStep.assigned_to" autocomplete="off">
           </div>
         </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button type="button" class="border-0 btn btn-primary btn-gradient-primary btn-rounded" @click.prevent="addNewStep" :disabled="btnDisabled" :key="btnEnableKey">{{ $t('save') }}</button>&nbsp;&nbsp;
        <button type="button" class="btn btn-secondary btn-rounded" @click.stop.prevent="showStep = false">{{ $t('cancel') }}</button>
      </span>
   </step-modal>
   <step-modal
     title="StepListModal"
     v-show="showList"
     width="100%"
     height="100%"
     ref="stepList">
     <div class="d-flex dkl-title-h4" style="background-color: #f3f1f1;" slot="header">
       <h4>Schritt Liste</h4>
       <a class="dkl-btn btn-md rounded-circle pull-right" @click.prevent="openStepModal" v-show="edit" href="#"><i class="fa fa-plus" aria-hidden="true"></i></a>
     </div>
     <div slot="body">
       <div class="table-responsive col-md-12">
         <table class="table table-striped mb-0">
           <tbody>
           <tr v-for="(step, index) in steps" :key="index" :class="step.status === 'Offen' ? '' : 'strikethrough'">
             <td><input type="checkbox" :id="'step' + index"  @click="stepCheckBox($event, step.id)" v-model="step.status !== 'Offen'" autocomplete="off"></td>
             <td>{{step.name }}</td>
             <td>{{step.status}}</td>
             <td>{{step.assigned_to}}</td>
             <td><div v-show="edit">
               <a class="dkl-btn rounded-circle pull-right" @click="editStep($event, index)" href="#"><i class="fa fa-info" aria-hidden="true"></i></a>
               <a class="dkl-btn rounded-circle pull-right" @click="confirmDeleteStep($event, index)" href="#"><i class="fa fa-trash" aria-hidden="true"></i></a>
             </div></td>
           </tr>
           </tbody>
         </table>
       </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button type="button" class="btn btn-secondary btn-rounded" @click.stop.prevent="closeStepList">{{ $t('save') }}</button>
      </span>
   </step-modal>
 </div>
</template>

<script>
import {service} from '@/utils/request.js';
import { CLOSED_STATUS, deepCopy, boolDisplay } from '@/utils/index.js';
import { newStep } from '@/utils/enums.js';
import {mapState, mapMutations} from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import Modal from "@/components/component/Modal";
export default {
  name: "Steps",
  components: {'step-modal': Modal},
  props: {
    totalSteps: {
      type: Array,
      default: () => [],
    },
    taskID: {
      type: Number,
      default: null
    },
    parentName: {
      type: String,
      default: 'add_massnahme'
    }
  },
  data() {
    return {
      currentStep: {
        id: null,
        task: null,
        name: '',
        modified_by: '',
        assigned_to: '',
        status: 'Offen',
      },
      showStep: false,
      showList: false,
      stepTitle: 'Neuer Schritt',
      steps: [],
      btnEnableKey: 1,
      btnDisabled: false,
    }
  },
  computed: {
    ...mapState({accountid: state => state.account.accountid, userName: state => state.user.username, account: state => state.account, userID: state => state.user.id, edit: state => state.app.edit}),
    first5Steps() {
      if (this.steps.length > 5) return this.steps.slice(0, 5)
      return this.steps
    },
    moreSteps() {
      if (this.totalSteps.length > 5) return true
      return false
    }
  },
  updated() {
    this.steps = this.totalSteps
  },
  validations() {
    return {
      currentStep: {
        name: {required, $lazy: true},
        modified_by: {required, $lazy: true},
      },
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  methods: {
    ...mapMutations({
      'setEdit': "SET_EDIT"
    }),
    closeStepList() {
      this.showList = false
      $(`#${this.parentName}`).children('.modal-dialog').css('transform', 'translateX(0px)')
      // this.$emit('stepListClosed', {parentName: this.parentName, ref: this.$refs.stepList})
    },
    openFullList() {
      this.showList = true
      $(`#${this.parentName}`).children('.modal-dialog').css('transform', 'translateX(-800px)')
      this.$refs.stepList.$el.style.cssText += 'transform: translateX(800px)'
      // this.$emit('openFullList', {parentName: this.parentName, ref: this.$refs.stepList})
    },
    openStepModal() {
      this.currentStep = deepCopy(newStep)
      this.currentStep.task = this.taskID
      this.currentStep.modified_by = this.userID
      this.showStep = true
    },
    editStep(e, index) {
      e.preventDefault();
      this.steps = this.totalSteps
      this.currentStep = this.steps[index];
      this.stepTitle = 'Schritt editieren'
      this.showStep = true
    },
    confirmDeleteStep(e, index) {
      e.preventDefault();
      this.$confirm(
        {
          message: 'Sicher, dass dieser Schritt gelöscht wird?',
          button: {
            no: 'Nein',
            yes: 'Ja'
          },
          callback: confirm => {
            if (confirm) {
              this.deleteStep(index)
            }
          }
        }
      )
    },
    deleteStep(index) {
      if (this.steps[index].id !== null) {
        service.request({
          url: `todos/v1/delete_step/${this.steps[index].id}/`,
          method: 'DELETE',
          responseType: 'json',
        }).then((response) => {
          this.$vToastify.success('Maßnahmen Schritt ist erfolgreich gelöscht!')
          this.steps.splice(index, 1);
          this.$emit('stepsUpdated', this.steps)
        })
      } else {
        console.log(index)
        this.steps.splice(index, 1)
      }
    },
    async addNewStep(e) {
      const isValid = await this.v$.currentStep.$validate()
      if (!isValid) {
        this.$vToastify.error('Bitte fehlende Felder vervollständigen!')
        return
      }
      this.btnDisabled = true
      if (this.currentStep.id == null) {
        this.steps.push(this.currentStep)
      } else {
        const stepIndex = this.steps.findIndex(step => step.id === this.currentStep.id)
        this.steps[stepIndex] = this.currentStep
      }
      this.btnDisabled = false
      this.$emit('stepsUpdated', this.steps)
      this.showStep = false;
    },
    stepCheckBox(e, id) {
      if (e.target.checked) {
        this.steps.filter((step) => step.id === id)[0].status = 'Abgeschlossen';
        this.$emit('stepsUpdated', this.steps)
        return false
      }
      this.steps.filter((step) => step.id === id)[0].status = 'Offen';
      this.$emit('stepsUpdated', this.steps)
    },
  }
}
</script>

<style>
.dkl-ml-075 {
  margin-left: 0.75rem;
}

.dkl-scale {
  float: right;
  background-color: gray;
  width: 100%;
  height: 100px;
  line-height: 100px;
  animation: main 3s;
  transform-origin: 0% 0%;
}

@keyframes main {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
</style>
